import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const singleProductAnimations = {
    addToCartButton: document.querySelector('#mobile-add-to-cart-button'),
    bind() {
        if (this.addToCartButton) {
            gsap.to(this.addToCartButton, {
                opacity: 0,
                scrollTrigger: {
                    trigger: 'footer#colophon',
                    start: 'top bottom',
                    end: 'top bottom-=' + this.addToCartButton.offsetHeight,
                    scrub: true,
                    invalidateOnRefresh: true,
                    markers: false,
                    onUpdate: self => this.addToCartButton.classList.toggle('hidden', self.progress === 1)

                }
            });
        }
    }
};